<section class="gift-item d-flex flex-column flex-md-row">

    <div class="gift-item-image-container p-3">
        <div class="gift-item-image-content">
            <div class="gift-item-image d-flex justify-content-center align-items-center"
                 [ngStyle]="{'background-image': 'url(' + gift.logoUrl + ')'}">
            </div>
            <div *ngIf="gift.partnerLogoUrl"
                 class="gift-item-logo"
                 [ngStyle]="{'background-image': 'url(' + gift.partnerLogoUrl + ')'}">
            </div>
        </div>
    </div>


  <div class="gift-item-info d-flex flex-column">
        <div class="d-flex flex-fill justify-content-center justify-content-md-end align-items-center">
            <h3 class="gift-item-info-title text-center text-md-right mb-0">
                {{gift.giftName | truncate:[55, '(...)'] }}
            </h3>
        </div>
        <div class="text-end">
            <button type="button"
                    class="btn btn-primary shadow-sm btn-lg"
                    (click)="goToGiftDetailsPage()"
                    [translate]="'GIFTS.LIST.BUTTON-CHOOSE'"></button>
        </div>
    </div>

</section>
